import styled from 'styled-components';
import MUIPaper from '@material-ui/core/Paper';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '../../../styleConstants';

const Paper = styled(MUIPaper)`
  padding: ${({ padding }) => padding || Spacings.SPACING_12B};
  background-color: ${({ theme, bgColor }) => bgColor || theme.colors.white};
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  grid-column: ${({ gridColumn }) => gridColumn};
  border-radius: 8px;
`;

export default Paper;
